// extracted by mini-css-extract-plugin
export default {"invalidate-trip":"styles_invalidate-trip__Ap3D2"};